import { http } from './_http';
import { logWebHrError } from '@/core/logger/log-wrapper';

/**
 * @return {Promise<AxiosResponse<any>>}
 */
export default async function postSuperapiEmbedUrl(
  superStepOnboardingSessionId
) {
  try {
    const { data } = await http.post(
      `/superstep/onboarding-sessions/${superStepOnboardingSessionId}/generate-url`
    );

    return {
      url: data.url,
      expiresAt: data.expiresAt,
    };
  } catch (e) {
    logWebHrError({
      message: 'Failed to get superapi embed url',
      source: 'get-superapi-embed-url',
      metadata: {
        superStepOnboardingSessionId,
      },
      error: e,
    });
    throw e;
  }
}
